import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as customFilters from "@/utils/filter";
import "@/utils/flexible.js"; //屏幕适配
import "@/assets/theme/blue/index.css"; //蓝色主题
import "@/assets/theme/red/index.css"; //红色主题
import "@/assets/font/iconfont.css"; //字体图标
import VueXss from "vue-xss";
import plugins from "./components/index";
import Element from "element-ui";

import Print from './utils/print'
Vue.use(Print);

import './permission'; // 路由守卫配置


// import VConsole from "vconsole";//移动端调试
// new VConsole();

//公共js
import base from '@/utils/base'
Vue.prototype.$base = base

Vue.use(plugins);
Vue.use(Element);
Vue.use(VueXss);
// 引入分页全局配置
import getPage from "@/utils/page";
Vue.prototype.$defalutPage = getPage;
// 环境变量
Vue.config.productionTip = false;
// 公共提示
Vue.prototype.$message = Element.Message;
// 全局过滤器
Object.keys(customFilters).forEach(key => {
  Vue.filter(key, customFilters[key]);
});


// 加密
import { phpEncrypt, phpDecrypt } from "@/utils/encryption";
Vue.prototype.$phpEncrypt = phpEncrypt;
Vue.prototype.$phpDecrypt = phpDecrypt;

//  全局事件总线
Vue.prototype.$bus = new Vue();
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
